export default {
  async getLeadsByCategoryKPI( _ , params) {
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/dashboard/leads-by-category?${query}`;      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async getLeadsByMonthKPI( _ , params) {
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/dashboard/leads-by-month?${query}`;      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async getRewardsByMonthKPI( _ , params) {
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/dashboard/reward-points-by-month?${query}`;      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async getLeadsByStatusKPI( _ , params) {
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/dashboard/leads-by-status?${query}`;      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async getParticipationByMonthKPI( _ , params) {
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/dashboard/participation-percentage-by-month?${query}`;      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
};
